/**
 * Canonical booking lifecycle-status metadata shared across the CRM
 * (list, detail, history) and the customer portal. Mirrors the backend
 * enum in backend/routes/booking_status.py. One source of truth for
 * labels + colours so a status always looks the same everywhere.
 */
export const STATUS_META = {
  pending_payment:       { label: 'Pending Payment',         badge: 'bg-amber-100 text-amber-800 border-amber-200',   dot: '#F59E0B', group: 'tentative' },
  confirmed:             { label: 'Confirmed',               badge: 'bg-emerald-100 text-emerald-800 border-emerald-200', dot: '#06D6A0', group: 'active' },
  partially_paid:        { label: 'Partially Paid',          badge: 'bg-sky-100 text-sky-800 border-sky-200',         dot: '#0EA5E9', group: 'active' },
  fully_paid:            { label: 'Fully Paid',              badge: 'bg-green-100 text-green-800 border-green-200',   dot: '#059669', group: 'active' },
  completed:             { label: 'Completed',               badge: 'bg-indigo-100 text-indigo-800 border-indigo-200', dot: '#6366F1', group: 'archive' },
  cancelled_non_payment: { label: 'Cancelled — Non-Payment', badge: 'bg-red-100 text-red-700 border-red-200',         dot: '#EF4444', group: 'cancelled' },
  hold_expired:          { label: 'Hold Expired',            badge: 'bg-red-100 text-red-700 border-red-200',         dot: '#DC2626', group: 'cancelled' },
  past_due:              { label: 'Past Due',                badge: 'bg-red-100 text-red-700 border-red-200',         dot: '#B91C1C', group: 'cancelled' },
  no_show:               { label: 'No-Show',                 badge: 'bg-stone-200 text-stone-700 border-stone-300',   dot: '#78716C', group: 'cancelled' },
  cancelled:             { label: 'Cancelled',               badge: 'bg-red-100 text-red-700 border-red-200',         dot: '#EF4444', group: 'cancelled' },
};

// Display / filter ordering (active first, terminal last).
export const STATUS_ORDER = [
  'pending_payment', 'confirmed', 'partially_paid', 'fully_paid', 'completed',
  'past_due', 'hold_expired', 'cancelled_non_payment', 'no_show', 'cancelled',
];

export const statusMeta = (s) =>
  STATUS_META[s] || { label: s || 'Unknown', badge: 'bg-gray-100 text-gray-700 border-gray-200', dot: '#9CA3AF', group: 'unknown' };
